import axios from "axios";
import { isGuid } from "./utilities";

export const setupAxiosDefaults = (baseUrl) => {
  const supportedLanguages = {
    en: "en-US",
    "en-US": "en-US",
    da: "da-DK",
    "da-DK": "da-DK",
  };
  const language =
    supportedLanguages[navigator.language] ?? supportedLanguages["en-US"];
  axios.defaults.baseURL = baseUrl;
  axios.defaults.headers = {
    "Content-Type": "application/json;charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    "Accept-Language": language,
  };
};

export const createFormApi = ({ data }) => {
  const args = isGuid(data) ? { guid: data } : { xml: data };
  return axios.post("/form/InitialiseForm", args);
};

export const getFormApi = ({ id }) => {
  return axios.get(`/form/GetForm/${id}`);
};

export const getFormFieldsApi = ({ id }) => {
  return axios.get(`/form/GetFormFields/${id}`);
};

export const executeActivityApi = (params) => {
  return axios.post("/form/ExecuteAndFormFields", params);
};

export const getGraphXmlApi = ({ id }) => {
  return axios.get(`/form/GetXml/${id}`);
};

export const formSubmitApi = (params) => {
  return axios.post("/form/submit", params);
};

export const uploadActivityApi = (url, params) => {
  return axios.post(url, params);
};

export const removeActivityApi = (url, params) => {
  return axios.delete(url, params);
};

export const getGraphJson = (url, params) => {
  return axios.post(url, params);
};
